






import { Component, Vue } from "vue-property-decorator";
import { getQueryParam } from "@/utils/index";
import PageResult from "@/components/PageResult.vue";
import {formatMessage} from "@/locale"

@Component({
    components: {
        "v-page-result": PageResult
    }
})
export default class NoFound extends Vue {
    icon: any = require("../../assets/images/ic_fail.png");
    msg: string = formatMessage({id:"message.common.notFound"});

    mounted() {
      
    }
}
